import { Link } from "react-router-dom";
import styled from "styled-components";
import { palette } from "./constants";
import { typography } from "./typography.styles";

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
`;

export const StyledLink = styled(Link)`
  color: ${palette.colors.green60};
`;

export const PageTitle = styled.div`
  ${typography.display_medium};
`;

export const Title = styled.div`
  ${typography.headline_large};
`;

export const ContentContainer = styled.div`
  max-width: 1208px;
  margin: 0 auto;
  padding: 48px 0;
`;

export const Back = styled.div`
  cursor: pointer;
  margin-bottom: 32px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  transition: all ease-in 0.1s;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: -16px;

  &:hover {
    background-color: rgba(27, 109, 36, 0.08);
  }
`;

export const TextLink = styled(Link)`
  color: ${palette.colors.link};
  ${typography.body_large_regular};
`;

export const ALink = styled.div`
  color: ${palette.colors.link};
  ${typography.body_large_regular};
  display: inline;
`;

export const HelperText = styled.div`
  ${typography.body_small_regular};
  position: absolute;
  bottom: -20px;
  left: 14px;
`;

export const RelativeContainer = styled.div`
  position: relative;
`;

export const VerticalCenter = styled.div`
  display: flex;
  align-items: center;
`;
